<gamut-branding [brand]="partnerBrandService.data.brand.brand" [scope]="scope" [endpoint]="endpoint"></gamut-branding>